import { conSimboloEuro } from '#components/mobile/ui/Importe';
import { useFormat } from '#hooks/useFormat';
import { useLanguage } from '#hooks/useLocale';

/** «3 de diciembre» (o «3 de desembre») de una fecha `YYYY-MM-DD`. */
export function fechaLarga(fecha: string, idioma: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
    return '';
  }
  return new Date(`${fecha}T12:00:00`).toLocaleDateString(idioma, {
    day: 'numeric',
    month: 'long',
  });
}

/** Formatos de los textos de Gavi: euros con «€» y fecha larga. */
export function useFormatosGavi() {
  const format = useFormat();
  const idioma = useLanguage();
  return {
    euros: (centimos: number) => conSimboloEuro(format(centimos, 'financial')),
    fecha: (fecha: string) => fechaLarga(fecha, idioma),
  };
}
